import React from 'react';
import Loadable from 'react-loadable';
import { Redirect, Switch } from 'react-router-dom';

import EditableRoute from '@components/EditableRoute';
import MobilePageWrapper from './components/PageWrapper';

const Loading = () => <div />;

const MobileDashboard = Loadable({
  loader: () => import('./pages/dashboard'),
  loading: Loading,
});

const MobileAppFunctions = Loadable({
  loader: () => import('./pages/appFunctions'),
  loading: Loading,
});

const Search = Loadable({
  loader: () => import('./pages/search'),
  loading: Loading,
});

const Assignment = Loadable({
  loader: () => import('./pages/assignment'),
  loading: Loading,
});

const MobileCodeFile = Loadable({
  loader: () => import('./pages/appSettings/codemaintenance'),
  loading: Loading,
});

const PriorityDefaults = Loadable({
  loader: () => import('./pages/appSettings/priorityDefaults'),
  loading: Loading,
});

const PropertyChanges = Loadable({
  loader: () => import('./pages/propertyChanges'),
  loading: Loading,
});

const MassProcessPendingChanges = Loadable({
  loader: () => import('./pages/massProcessPendingChanges'),
  loading: Loading,
});

const PropertySearch = Loadable({
  loader: () => import('./pages/propertySearch'),
  loading: Loading,
});

const ProductivityLog = Loadable({
  loader: () => import('./pages/productivityLog'),
  loading: Loading,
});

export const MobileRoute = {
  Dashboard: '/mobile/dashboard',
  AppFunctions: '/mobile/app-functions',
  CodeFileMaintenance: '/mobile/code-file-maintenance',
  PriorityDefaults: '/mobile/priority-defaults',
  Search: '/mobile/manager',
  AssignmentCreate: '/mobile/assignment/create',
  Assignment: '/mobile/assignment/:mobileAssignmentID/:tab',
  AssignmentValidation: '/mobile/assignment/:mobileAssignmentID/validation',
  PropertyChanges: '/mobile/property-changes',
  MassProcessPendingChanges: '/mobile/mass-changes/:changesetGroupID',
  PropertySearch: '/mobile/property-search',
  ProductivityLog: '/mobile/productivity-log',
};

export const MobilePageTitle = {
  [MobileRoute.Dashboard]: 'Dashboard',
  [MobileRoute.AppFunctions]: 'App Functions',
  [MobileRoute.CodeFileMaintenance]: 'Code File Maintenance',
  [MobileRoute.Search]: 'Mobile Manager',
  [MobileRoute.AssignmentCreate]: 'Mobile Manager Assignment Create',
  [MobileRoute.Assignment]: 'Mobile Manager Assignment',
  [MobileRoute.PropertyChanges]: 'Property Changes',
  [MobileRoute.MassProcessPendingChanges]: 'Mass Process Pending Changes',
  [MobileRoute.PropertySearch]: 'Property Search',
  [MobileRoute.ProductivityLog]: 'Productivity Log',
  [MobileRoute.PriorityDefaults]: 'Priority Defaults',
};

const MobileRoutes = props => (
  <MobilePageWrapper {...props}>
    <Switch>
      <EditableRoute
        component={MobileDashboard}
        exact
        path={MobileRoute.Dashboard}
      />
      <EditableRoute
        component={MobileAppFunctions}
        exact
        path={MobileRoute.AppFunctions}
      />
      <EditableRoute
        component={MobileAppFunctions}
        exact
        path={MobileRoute.AppFunctions}
      />
      <EditableRoute
        component={MobileCodeFile}
        exact
        path={MobileRoute.CodeFileMaintenance}
      />
      <EditableRoute
        component={PriorityDefaults}
        exact
        path={MobileRoute.PriorityDefaults}
      />
      <EditableRoute
        component={PropertyChanges}
        exact
        path={MobileRoute.PropertyChanges}
      />
      <EditableRoute component={Search} exact path={MobileRoute.Search} />
      <EditableRoute
        component={Assignment}
        exact
        path={MobileRoute.Assignment}
      />
      <EditableRoute
        component={Assignment}
        exact
        path={MobileRoute.AssignmentCreate}
      />
      <EditableRoute
        component={MassProcessPendingChanges}
        exact
        path={MobileRoute.MassProcessPendingChanges}
      />
      <EditableRoute
        component={PropertySearch}
        exact
        path={MobileRoute.PropertySearch}
      />
      <EditableRoute
        component={ProductivityLog}
        exact
        path={MobileRoute.ProductivityLog}
      />
      <Redirect to={MobileRoute.Search} />
    </Switch>
  </MobilePageWrapper>
);

export default MobileRoutes;
